import { PAQUETES } from '../actions/types';

const initialState = {
    listado: [],
    detalles: null
};

export default (state = initialState, action) => {
    const { type, payload } = action;

    switch(type) {
        case PAQUETES.BUSCAR:
            return {
                ...state,
                listado: payload
            };

        case PAQUETES.DETALLES:
            return {
                ...state,
                detalles: payload
            };

        default:
            return state;
    }
}
